import {Outlet, RouteObject, useRoutes} from 'react-router-dom';
import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {ActiveWorkspaceProvider} from '@common/workspace/active-workspace-id-context';
import { AuthRoute } from '@common/auth/guards/auth-route';
import { PricingEngineSetupLayout } from '@common/pricing-engine-setup/pricing-engine-setup-layout';
import { MarketRatePage } from './market-rates-page';

export default function MarketRateRoutes() {
  const DashboardRouteConfig: RouteObject[] = [
    {
      path: '',
      element: <PricingEngineSetupLayout />,
      children: [
        {
          path: '/',
          element: (
            <AuthRoute permission="market_rates.view">
              <MarketRatePage />
            </AuthRoute>
          ),
        },

        {path: '*', element: <NotFoundPage />},
      ],
    },
  ];

  return useRoutes(DashboardRouteConfig);
}
